module.exports = __webpack_public_path__ + "img/LU.ba963f79.svg";